import { ref } from 'vue';

const callers = ref([]);
const ringing_callers = ref([]);

const activeExtCall = ref(null);

export async function initCallManager() {
  console.log("Initializing call manager...");
}

// 3. API Actions
export async function talkToCaller(callerId) {
  try {
    const response = await fetch('/api/queue/talk', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ 
        caller_id: callerId
      })
    });
    if (response.ok) activeExtCall.value = await response.json();
  } catch (err) {
    console.error("Failed to bridge call", err);
  }
}

export async function callerOnAir(callerId) {
  try {
    const response = await fetch('/api/queue/onair', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ 
        caller_id: callerId
      })
    });
    if (response.ok) activeExtCall.value = await response.json();
  } catch (err) {
    console.error("Failed to bridge call", err);
  }
}

export async function requeueCaller(callerId) {
  try {
    const response = await fetch('/api/queue/requeue', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ caller_id: callerId })
    });
    if (response.ok) activeExtCall.value = null;
  } catch (err) {
    console.error("Failed to requeue", err);
  }
}

export async function callerHold(callerId) {
  try {
    const response = await fetch('/api/queue/hold', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ caller_id: callerId })
    });
  } catch (err) {
    console.error("Failed to place call on hold", err);
  }
}

export async function hangupCall(callerId) {
  try {
    const response = await fetch('/api/queue/hangup', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ caller_id: callerId })
    });
    if (response.ok) activeExtCall.value = null;
  } catch (err) {
    console.error("Failed to requeue", err);
  }
}

export async function muteCaller(callerId, mute, direction) {
  try {
    const response = await fetch('/api/caller/mute', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ caller_id: callerId, mute: mute, direction: direction })
    });
    if (response.ok) {
      let resp = await response.json();
      activeExtCall.value.mute_status = resp["status"]
    }
  } catch (err) {
    console.error("Failed to requeue", err);
  }
}  

export function getState() {
  console.log("activeExtCall", activeExtCall);
  return { callers, ringing_callers, activeExtCall };
}